package com.example.mystybag.core.expected

import kotlin.js.console

actual object LogHelper {
    actual fun logExceptionEvent(e: Exception) { console.error(e.toString()) }
    actual fun setCrashlyticsUserId(userId: String) {}
    actual fun logEvent(message: String) { console.log(message) }
    actual fun logAnalyticsEvent(eventName: String, parameters: Map<String, String>) {}
}
